export enum PortraitSizeForMobileType {
  PortraitLarge = 'portraitLarge',
  PortraitSmall = 'portraitSmall',
}
